var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDashboardForYou = function SvgIconDashboardForYou(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 22,
    fill: "#0072BC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.539 21.268h-7.59l.959-5.639v-.33a1.8 1.8 0 0 0-.496-1.158L23.27 13l-7.607 8.268a2.13 2.13 0 0 0-.661 1.654v8.268a3.317 3.317 0 0 0 3.307 3.307h9.095a2.21 2.21 0 0 0 2.15-1.323l3.472-8.103c.133-.248.199-.545.166-.827v-1.322c0-.91-.745-1.654-1.654-1.654"
  })));
};
export default SvgIconDashboardForYou;